/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Audio_Delete_ErrorInputs */

const en_dialog_audio_delete_error = /** @type {(inputs: Dialog_Audio_Delete_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There was an error while deleting the audio item`)
};

const es_dialog_audio_delete_error = /** @type {(inputs: Dialog_Audio_Delete_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubo un error al eliminar el elemento de audio`)
};

/**
* | output |
* | --- |
* | "There was an error while deleting the audio item" |
*
* @param {Dialog_Audio_Delete_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_audio_delete_error = /** @type {((inputs?: Dialog_Audio_Delete_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Audio_Delete_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_audio_delete_error(inputs)
	return en_dialog_audio_delete_error(inputs)
});